var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticStyle:{"padding":"4px"},attrs:{"plain":"","elevation":"0","text":""},on:{"click":_vm.openRiskMatrixDialog}},[_c('v-icon',[_vm._v("mdi-table")]),_vm._v(" "+_vm._s(_vm.__('company.components.risk-assessments.button'))+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }